const GC = window.__GENERATED_CONSTANTS__

export const WorkflowStatusType = {
    OPEN: GC.WorkflowStatusType.OPEN,
    COMPLETED: GC.WorkflowStatusType.COMPLETED
}

export const COLORS = {
    PINK: 0,
    ORANGE: 1,
    YELLOW: 2,
    LIGHT_GREEN: 3,
    DARK_GREEN: 4,
    AQUAMARINE: 5,
    BLUE: 6,
    VIOLET: 7,
    LIGHT_GRAY: 8,
    DARK_GRAY: 9
}

export const DEFAULT_COLOR_ID = COLORS.PINK

/**
 * Map used for bound color id with css class contains relative colors
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusColorMixin` mixin
 * @type {{}}
 */
export const CLASS_MAP_BY_COLOR = {
    [COLORS.PINK]: 'statusColor_pink',
    [COLORS.ORANGE]: 'statusColor_orange',
    [COLORS.YELLOW]: 'statusColor_yellow',
    [COLORS.LIGHT_GREEN]: 'statusColor_lightGreen',
    [COLORS.DARK_GREEN]: 'statusColor_darkGreen',
    [COLORS.AQUAMARINE]: 'statusColor_aquamarine',
    [COLORS.BLUE]: 'statusColor_blue',
    [COLORS.VIOLET]: 'statusColor_violet',
    [COLORS.LIGHT_GRAY]: 'statusColor_lightGray',
    [COLORS.DARK_GRAY]: 'statusColor_darkGray'
}

/**
 * Map used for bound status type with css class with relative type images
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusTypeMixin` mixin
 * @type {{}}
 */
export const CLASS_MAP_BY_STATUS_TYPE = {
    [WorkflowStatusType.OPEN]: 'statusType_open',
    [WorkflowStatusType.COMPLETED]: 'statusType_completed'
}

/**
 * Map used for bound status type with css class with relative type images. Use with CLASS_MAP_BY_STATUS_TYPE
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusTypeMixin` mixin
 * @type {{}}
 */
export const STATUS_TYPE_CLASS_MAP_BY_COLOR = {
    [COLORS.PINK]: 'statusTypeIcon_pink',
    [COLORS.ORANGE]: 'statusTypeIcon_orange',
    [COLORS.YELLOW]: 'statusTypeIcon_yellow',
    [COLORS.LIGHT_GREEN]: 'statusTypeIcon_lightGreen',
    [COLORS.DARK_GREEN]: 'statusTypeIcon_darkGreen',
    [COLORS.AQUAMARINE]: 'statusTypeIcon_aquamarine',
    [COLORS.BLUE]: 'statusTypeIcon_blue',
    [COLORS.VIOLET]: 'statusTypeIcon_violet',
    [COLORS.LIGHT_GRAY]: 'statusTypeIcon_lightGray',
    [COLORS.DARK_GRAY]: 'statusTypeIcon_darkGray'
}


export const FAKE_OPEN_WORKFLOW_STATUS_ID = -10
export const FAKE_COMPLETED_WORKFLOW_STATUS_ID = -20

/**
 * Array of statuses that used when TWS feature off.
 * @type {*[]}
 */
export const FAKE_WORKFLOW_STATUSES = [
    {
        id: FAKE_OPEN_WORKFLOW_STATUS_ID,
        type: WorkflowStatusType.OPEN,
        position: 0,
        colorId: COLORS.LIGHT_GREEN,
        name: 'Open'
    },
    {
        id: FAKE_COMPLETED_WORKFLOW_STATUS_ID,
        type: WorkflowStatusType.COMPLETED,
        position: 1,
        colorId: COLORS.DARK_GRAY,
        name: 'Completed'
    }
]


// WEBPACK FOOTER //
// ./web/js/workflowStatus/constants.js